import React from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  title: { color: theme.palette.primary.main, marginBottom: '16px', fontWeight: 'bold' },
  input: {
    width: '100%',
  },
}));

export default function TestSelectOption({ title, value, options, handleChange }) {
  const classes = useStyles();
  return (
    <Grid item xs={12} md={6}>
      <Typography className={classes.title}>{title}</Typography>
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="select-label">{title}</InputLabel>
        <Select
          labelId="select-label"
          id="select-option-input"
          value={value}
          onChange={e => handleChange(e.target.value)}
          label={title}>
          {options.map((option, index) => {
            return (
              <MenuItem value={option.value} key={index}>
                {option.optName}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Grid>
  );
}
